import React from "react";
import "./socials.css";
import { FiTwitter, FiLinkedin, FiGithub } from "react-icons/fi";
import { Fade } from "react-reveal";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Socials = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return null;
  }

  const { personal } = data;

  return (
    <Fade delay={800}>
      <div className="socials-container">
        <a
          className="social"
          href={personal.twitter}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiTwitter />
        </a>
        <a
          className="social"
          href={personal.linkedin}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiLinkedin />
        </a>
        <a
          className="social last-social"
          href={personal.github}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiGithub />
        </a>
        <div className="socials-line"></div>
      </div>
    </Fade>
  );
};

export default Socials;
